// extracted by mini-css-extract-plugin
export default {"label":"FiltersOptions_label__-913L","labelText":"FiltersOptions_labelText__TZYwJ","checkbox":"FiltersOptions_checkbox__BcR2z","disabled":"FiltersOptions_disabled__vRwnA"};